export const MAPPING_EXIST = "Mapping already exist";
export const SELECT_SERVICE_FOR_XREF =
  "Please select a service for each mapping";
export const THE_MAPPING_VALUE_ENTERED_CONTAINS_AN_INVALID_CHARACTER =
  "The mapping value entered contains an invalid character";
export const REGEX_MAPPING = /(\$|%|#|\.|`|'|\[|\]|\*|&|\^|"|!|£|\/)/;

export const SERVICE_XREF_MAPPINGS_FIELD = "serviceXrefMappings";
